"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HE3ProductionQuotas = void 0;
const CardName_1 = require("../../CardName");
const CardType_1 = require("../CardType");
const Tags_1 = require("../Tags");
const CardRenderer_1 = require("../render/CardRenderer");
const CardRequirements_1 = require("../CardRequirements");
const PartyName_1 = require("../../turmoil/parties/PartyName");
const MoonExpansion_1 = require("../../moon/MoonExpansion");
const TileType_1 = require("../../TileType");
const Card_1 = require("../Card");
const Turmoil_1 = require("../../turmoil/Turmoil");
const constants_1 = require("../../constants");
const TurmoilHandler_1 = require("../../turmoil/TurmoilHandler");
const RedsPolicy_1 = require("../../turmoil/RedsPolicy");
const PartyHooks_1 = require("../../turmoil/parties/PartyHooks");
const Units_1 = require("../../Units");
const Size_1 = require("../render/Size");
class HE3ProductionQuotas extends Card_1.Card {
    constructor() {
        super({
            name: CardName_1.CardName.HE3_PRODUCTION_QUOTAS,
            cardType: CardType_1.CardType.EVENT,
            tags: [Tags_1.Tags.MOON],
            cost: 10,
            tr: { moonMining: 1 },
            requirements: CardRequirements_1.CardRequirements.builder((b) => b.party(PartyName_1.PartyName.KELVINISTS).miningTiles(1).any()),
            metadata: {
                cardNumber: 'M57',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.moonMine().any.nbsp().colon().nbsp().minus().steel(1).plus().heat(4).digit.br;
                    b.moonMiningRate();
                    b.text('(Requires that Kelvinists are ruling or that you have 2 delegates there, and 1 mine tile on the Moon. Pay 1 steel per mine tile on the Moon to gain 4 heat per mine tile on the Moon. Raise the Mining Rate 1 step.)', Size_1.Size.TINY, false, false);
                }),
            },
        });
    }
    ;
    canPlay(player) {
        const trGain = player.computeTerraformRatingBump(this);
        Card_1.Card.setRedsWarningText(player, trGain, this);
        const turmoil = Turmoil_1.Turmoil.getTurmoil(player.game);
        const hasMiningTileOnMoon = MoonExpansion_1.MoonExpansion.tiles(player.game, TileType_1.TileType.MOON_MINE, { surfaceOnly: true }).length >= 1;
        const moonTiles = MoonExpansion_1.MoonExpansion.tiles(player.game, TileType_1.TileType.MOON_MINE, { surfaceOnly: true });
        const canAffordSteelCost = player.steel >= moonTiles.length;
        if (!hasMiningTileOnMoon)
            return false;
        if (!canAffordSteelCost)
            return false;
        let canAffordReds = true;
        if (PartyHooks_1.PartyHooks.shouldApplyPolicy(player, PartyName_1.PartyName.REDS)) {
            this.reserveUnits = Units_1.Units.adjustUnits(this.reserveUnits, { megacredits: trGain * constants_1.REDS_RULING_POLICY_COST });
            const actionDetails = this.getActionDetails(player, this);
            this.howToAffordReds = RedsPolicy_1.RedsPolicy.canAffordRedsPolicy(player, player.game, actionDetails, false, false, false, false, true);
            if (this.howToAffordReds.mustSpendAtMost !== undefined || this.howToAffordReds.bonusMCFromPlay !== undefined) {
                this.reserveUnits = Units_1.Units.maybeAdjustReservedMegacredits(player, this.reserveUnits, this.howToAffordReds);
            }
            canAffordReds = this.howToAffordReds.canAfford;
        }
        else {
            this.howToAffordReds = undefined;
        }
        if (turmoil.parties.find((p) => p.name === PartyName_1.PartyName.KELVINISTS)) {
            const meetsPartyRequirements = turmoil.canPlay(player, PartyName_1.PartyName.KELVINISTS);
            if (PartyHooks_1.PartyHooks.shouldApplyPolicy(player, PartyName_1.PartyName.REDS)) {
                return meetsPartyRequirements && canAffordReds;
            }
            return meetsPartyRequirements;
        }
        let societyCost = player.getCardCost(this) + constants_1.SOCIETY_ADDITIONAL_CARD_COST;
        if (this.reserveUnits.megacredits > 0)
            societyCost += this.reserveUnits.megacredits;
        return player.canAfford(societyCost);
    }
    play(player) {
        const moonTiles = MoonExpansion_1.MoonExpansion.tiles(player.game, TileType_1.TileType.MOON_MINE, { surfaceOnly: true });
        player.steel -= moonTiles.length;
        player.heat += (4 * moonTiles.length);
        MoonExpansion_1.MoonExpansion.raiseMiningRate(player);
        TurmoilHandler_1.TurmoilHandler.handleSocietyPayment(player, PartyName_1.PartyName.KELVINISTS);
        return undefined;
    }
    getActionDetails(player, card) {
        const bonusMegaCredits = player.cardIsInEffect(CardName_1.CardName.SUITABLE_INFRASTRUCTURE) && player.willGainProductionFromMoonTrackIncrease(this.tr) ? 2 : 0;
        return new RedsPolicy_1.ActionDetails({ card: card, moonMiningRateIncrease: 1, bonusMegaCredits: bonusMegaCredits });
    }
}
exports.HE3ProductionQuotas = HE3ProductionQuotas;
//# sourceMappingURL=HE3ProductionQuotas.js.map